import * as React from "react";
import { DragSource, DragSourceCollector, ConnectDragSource, DragSourceSpec } from "react-dnd";

export interface Props {
  feature: string;
  connectDragSource?: ConnectDragSource;
  onDragStart(): void;
  onDragEnd(): void;
}

class CompanyValuesDragSource extends React.PureComponent<Props> {
  public render() {
    const { connectDragSource, children } = this.props;
    return connectDragSource!(<div>{children}</div>);
  }
}

const dragSource: DragSourceSpec<Props> = {
  beginDrag(props) {
    const { feature, onDragStart } = props;
    onDragStart();
    return { feature };
  },
  endDrag(props) {
    props.onDragEnd();
  },
};

const collect: DragSourceCollector = (connect, monitor) => {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
};

export default DragSource("company_values/sorter", dragSource, collect)(CompanyValuesDragSource);



// WEBPACK FOOTER //
// ./frontend/src/company_values/components/CompanyValuesDragSource.tsx